import React from 'react';
import styles from './XpGainReward.module.scss';
import { useTranslation } from 'react-i18next';
import { Button } from 'react-bootstrap';
import { SideFlagXPGain } from '../SideFlagXPGain';

import cdhLogo from '../../assets/imgs/bind/img-logo-cdh.png';
import levelLogo from '../../assets/imgs/bind/icon-level.png';
import gemLogo from '../../assets/imgs/bind/icon-gem.png';
import towerLogo from '../../assets/imgs/logo-tower.png';
import bindBoxDivider from '../../assets/imgs/bind/img-d-line-long.png';
import TowerTokenIcon from '../../assets/imgs/tower-token 1.png';
import RewardPoolImage from '../../assets/imgs/reward-pool-info.png';
import { NoBattleCardsOwnedNotice } from '../ViewTower/NoBattleCardsOwnedNotice';

const XpGainReward = ({ towerPerson, cdhUserId, cdhUserDetails, signOut, userBattleCardCount, userTicketCount }) => {
    const [t] = useTranslation();
    const earn_xp = '600,000';
    const rewards_pool = '1,800,000';

    const old_xp_gain_ui = (
        <div className={styles.body}>
            <div className={styles.bind_section}>
                <div className={styles.section_title}>{t('XP_GAIN_REWARD')}</div>
                <div className={styles.bind_box_divider_parent}><div className={styles.bind_box_divider}><img src={bindBoxDivider} alt="divider" /></div></div>
                <div className={styles.details}>
                    <div className={styles.cdh_logo}>
                        <img src={cdhLogo} className={styles.cdh_logo} alt="cdh-logo" />
                    </div>
                    <div className={styles.user_info}>
                        <div className={styles.bind_texts}>{t('NO_TOWER_EARNING_TITLE')}</div>
                        <div className={styles.item_info}>
                            <div className={styles.item_img}>
                                <img src={towerLogo} alt="tower-icon" />
                            </div>
                            <div>{towerPerson?.towerTokenEarned}</div>
                        </div>
                        <div className={styles.bind_texts}>{t('GAME_ID')}</div>
                        <div className={styles.item_info}>
                            <div>{cdhUserId}</div>
                        </div>
                        <div className={styles.level_gems}>
                            <div className={styles.item_info}>
                                <div className={styles.item_img}>
                                    <img src={levelLogo} alt="tower-icon" />
                                </div>
                                <div>Level {cdhUserDetails?.Avatar?.AvatarLevel}</div>
                            </div>
                            <div className={styles.item_info}>
                                <div className={styles.item_img}>
                                    <img src={gemLogo} alt="tower-icon" />
                                </div>
                                <div>{cdhUserDetails?.Currencies?.Gems}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.logout_button_container}><Button variant="cdh-general-white" className={styles.logout_button} onClick={signOut}>{t('LOGOUT')}</Button></div>
            </div>
        </div>
    )

    return (
        <div className={styles.xp_gain_rewards}>
            <div className={styles.side_flag_container}>
                <SideFlagXPGain earn_xp={earn_xp} rewards_pool={rewards_pool} />
            </div>
            <div className={styles.section_title}>
                <div className={styles.title_text}>
                    <span className={styles.title}>{t('XP_GAIN_REWARD')}</span>
                </div>
            </div>
            
            <div className={styles.xp_gain_body_container}>
                <NoBattleCardsOwnedNotice battleCardsCount={userBattleCardCount} userTicketCount={userTicketCount} />

                <div className={styles.container_section_headers}>
                    <div className={styles.total_event_earning}>
                        <img src={TowerTokenIcon} alt="tower-token" />
                        <div>
                            <div>{t('XP_GAIN_REWARD')}</div>
                            <div className={styles.token_count}>{towerPerson?.towerTokenEarned}</div>
                        </div>
                    </div>
                </div>

                <div className={styles.xp_gain_body}>
                    <img src={RewardPoolImage} alt="reward-pool" />
                    <div className={styles.xp_gain_heading}>{t('GAIN')} {earn_xp} {t('XP_TO_EARN_REWARDS_POOL')} {rewards_pool}</div>
                    <div className={styles.xp_gain_description}>
                        {t('XP_GAIN_REWARD_DESCRIPTION')}
                    </div>
                    <div className={styles.event_details_link}>
                        <a href="https://medium.com/tower-token/" target="_blank" rel="noopener noreferrer">
                            {t('EVENT_DETAILS')}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    )
}

export { XpGainReward };
